import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-telecaller-verification-modal',
  standalone: true,
  imports: [CommonModule, ModalComponent],
  templateUrl: './telecaller-verification-modal.component.html',
})
export class TelecallerVerificationModalComponent {
  @Input() isOpen: boolean = false;
  @Input() exotelNumber: string | null = null;
  @Input() missedCallNumber: string = '09513885656';
  @Input() isChecking: boolean = false;
  @Input() errorMessage: string | null = null;

  @Output() checkVerification = new EventEmitter<void>();

  onCheckVerification(): void {
    this.checkVerification.emit();
  }
}
